import { setResetPasswordStatus } from "actions/user";
import { put, takeLeading } from "redux-saga/effects";
import { post } from "sagas/helpers/network";

function* execute(action: sage.actions.user.IResetPassword) {
    yield put(setResetPasswordStatus("loading"));
    try {
        const payload = {
            email: action.email,
            password: action.password,
            code: action.code,
        };
        yield post("/set-reset-password", payload);
        yield put(setResetPasswordStatus("success"));
    } catch {
        yield put(setResetPasswordStatus("error"));
    }
}

export default function* saga(): Generator {
    yield takeLeading("com.sage.actions.user.IResetPassword", execute);
}
